var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-btn",
    _vm._g(
      _vm._b(
        { staticClass: "a-button-primary", attrs: { variant: "primary" } },
        "b-btn",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }